export default __webpack_public_path__ + "static/media/gallery-wip-ammo-port-enclosure-body_00.0e2fa669.jpg";